import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ArrowRightLong: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 20, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 15) / 20}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.7338 6.82567L13.3701 0.263168C13.1987 0.0923945 12.969 -0.00210058 12.7307 3.54398e-05C12.4923 0.00217146 12.2643 0.100768 12.0957 0.274588C11.9272 0.448408 11.8316 0.683544 11.8295 0.929354C11.8274 1.17516 11.9191 1.41198 12.0847 1.58879L16.8965 6.55098H0.9091C0.667992 6.55098 0.436758 6.64975 0.266269 6.82557C0.0957798 7.00138 0 7.23984 0 7.48848C0 7.73712 0.0957798 7.97558 0.266269 8.15139C0.436758 8.32721 0.667992 8.42598 0.9091 8.42598H16.8965L12.0847 13.3882C11.9978 13.4746 11.9286 13.5781 11.8809 13.6925C11.8333 13.8069 11.8082 13.9299 11.8072 14.0544C11.8061 14.1788 11.8291 14.3023 11.8748 14.4175C11.9205 14.5327 11.988 14.6374 12.0734 14.7254C12.1588 14.8134 12.2603 14.883 12.372 14.9302C12.4837 14.9773 12.6034 15.001 12.7241 15C12.8448 14.9989 12.9641 14.973 13.075 14.9239C13.186 14.8748 13.2863 14.8033 13.3701 14.7138L19.7338 8.15129C19.9043 7.97548 20 7.73707 20 7.48848C20 7.23989 19.9043 7.00147 19.7338 6.82567Z"
        fill="currentColor"
      />
    </svg>
  )
})

ArrowRightLong.displayName = 'ArrowRightLong'
